import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/shared/api';
import type { ManualBookingPriceInput } from '@/shared/api/types/manualBookingPrice';

export function useManualPricePreview(
  input: ManualBookingPriceInput,
  enabled: boolean,
  bookingId?: string,
) {
  const api = useApi();
  return useQuery({
    queryKey: ['manual-booking-price', bookingId, input],
    queryFn: () => api.bookings.previewManualPrice(input, bookingId),
    enabled,
    retry: false,
  });
}
